import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

export interface DayStats {
  notStarted: number;
  inProgress: number;
  done: number;
}

interface AdminDashboardStatsProps {
  stats: DayStats;
  className?: string;
}

export function AdminDashboardStats({ stats, className }: AdminDashboardStatsProps) {
  const { t } = useTranslation();
  return (
    <div
      className={cn(
        "flex flex-wrap gap-4 rounded-lg border border-border bg-card p-4",
        className
      )}
    >
      <div className="flex items-center gap-2">
        <span className="h-3 w-3 rounded-full bg-red-500" aria-hidden />
        <span className="text-sm font-medium text-muted-foreground">
          {t("admin.dashboard.notStarted")}
        </span>
        <span className="text-lg font-bold tabular-nums">{stats.notStarted}</span>
      </div>
      <div className="flex items-center gap-2">
        <span className="h-3 w-3 rounded-full bg-yellow-500" aria-hidden />
        <span className="text-sm font-medium text-muted-foreground">{t("admin.dashboard.inProgress")}</span>
        <span className="text-lg font-bold tabular-nums">{stats.inProgress}</span>
      </div>
      <div className="flex items-center gap-2">
        <span className="h-3 w-3 rounded-full bg-green-500" aria-hidden />
        <span className="text-sm font-medium text-muted-foreground">{t("admin.dashboard.finished")}</span>
        <span className="text-lg font-bold tabular-nums">{stats.done}</span>
      </div>
    </div>
  );
}
